module.exports = __webpack_public_path__ + "static/media/work_2.2e85102f.jpg";